/* eslint-disable no-throw-literal */
import {
  GET_SAFETY_CONFIRMATION_LIST,
  GET_SAFETY_CONFIRMATION_DETAIL,
  CREATE_SAFETY_CONFIRMATION,
  UPDATE_SAFETY_CONFIRMATION,
  CLOSE_SAFETY_CONFIRMATION,
  GET_SAFETY_CONFIRMATION_ANSWER_LIST
} from './mutation-types'

export default {
  state: {
    safetyConfirmationSearchShop: undefined,
    safetyConfirmationSearchStatus: undefined,
    safetyConfirmationSearchCanHelp: undefined,
    safetyConfirmationSearchUser: undefined
  },
  getters: {
    serviceQuestionSearchShop: state => {
      return state.serviceQuestionSearchShop
    },
    safetyConfirmationSearchStatus: state => {
      return state.safetyConfirmationSearchStatus
    },
    safetyConfirmationSearchCanHelp: state => {
      return state.safetyConfirmationSearchCanHelp
    },
    safetyConfirmationSearchUser: state => {
      return state.safetyConfirmationSearchUser
    }
  },
  actions: {
    [GET_SAFETY_CONFIRMATION_LIST] ({ dispatch }, params) {
      console.log('GET_SAFETY_CONFIRMATION_LIST')
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/safety_confirmations/safety_confirmations', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_SAFETY_CONFIRMATION_ANSWER_LIST] ({ dispatch, state }, params) {
      console.log('GET_SAFETY_CONFIRMATION_LIST')
      state.safetyConfirmationSearchShop = params.data['search_shop']
      state.safetyConfirmationSearchStatus = params.data['search_status']
      state.safetyConfirmationSearchCanHelp = params.data['search_can_help']
      state.safetyConfirmationSearchUser = params.data['search_user']
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/safety_confirmations/safety_confirmations/${params.id}/answers`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [CREATE_SAFETY_CONFIRMATION] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/safety_confirmations/safety_confirmations', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [UPDATE_SAFETY_CONFIRMATION] ({ dispatch }, params) {
      console.log('UPDATE_SAFETY_CONFIRMATION')
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/safety_confirmations/safety_confirmations/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [CLOSE_SAFETY_CONFIRMATION] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', { url: `/master/safety_confirmations/safety_confirmations/${params.id}` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_SAFETY_CONFIRMATION_DETAIL] ({ dispatch }, params) {
      console.log('GET_SAFETY_CONFIRMATION_DETAIL')
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/safety_confirmations/safety_confirmations/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/safety-confirmation.js